export const GRID_TYPES = {
  tian: { name: '田字格', lines: ['cross'] as const },
  mi: { name: '米字格', lines: ['cross', 'diagonal'] as const },
  fang: { name: '方格', lines: [] as const }
}

export const PAPER = {
  width: 794,
  height: 1123,
  cellSize: 56,
  dprScale: 2
}

export const LETTER_PAPER = {
  width: 816,
  height: 1056,
  cellSize: 56,
  dprScale: 2
}

export const TRACE_COUNT_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 8, 10, 11] as const

export const FONT_OPTIONS = {
  wenkai: { name: '霞鹜文楷', family: '"LXGW WenKai", "STKaiti", "KaiTi", serif' },
  songti: { name: '思源宋体', family: '"Noto Serif SC", "Source Han Serif SC", "SimSun", serif' },
  youqu: { name: '游趣体', family: '"LXGW WenKai", "STKaiti", "KaiTi", serif' },
} as const

export const DEFAULT_HANZI_CONFIG = {
  chars: '我爱学习汉字',
  gridType: 'mi' as const,
  traceCount: 3,
  insertBlankRow: false,
  insertBlankCol: false,
  showStrokeOrder: false,
  traceColor: '#E74C3C',
  lineColor: '#9E9E9E',
  paperSize: 'a4' as const,
  fontFamily: 'wenkai' as const,
  showPinyin: false,
}

export const PAGE_PADDING = { top: 18, right: 56, bottom: 65, left: 56 }
export const TITLE_HEIGHT = 16
export const INFO_HEIGHT = 0

export const TRACE_COLORS = [
  '#E74C3C',
  '#F39C12',
  '#3498DB',
  '#9B59B6',
  '#27AE60',
  '#333333'
] as const
